import {reactive} from "@vue/composition-api";
import {DemoParameters} from "./BuilderDemoData";
import {ProjectBuilderSettingsInterface} from "@tool/tool.types";
import {BuilderParametersByType, BuilderStats, BuilderUrlInterface} from "@tool/Builder/Builder.types";

export default function useBuilderLocalStorage() {
    const updateUrls: (urls: BuilderUrlInterface[]) => void = (urls) => {
        localStorage.setItem('utmtool-urls', JSON.stringify(urls));
    };

    const getUrls: () => BuilderUrlInterface[] = () => {
        let storage = localStorage.getItem('utmtool-urls');

        if (!storage) {
            const urls = reactive<BuilderUrlInterface[]>([]);

            updateUrls(urls);

            return urls;
        }

        let urls = reactive(JSON.parse(storage));

        return reactive(urls.map((url: BuilderUrlInterface) => {
            // @ts-ignore
            if (typeof url._showDetails !== 'undefined') {
                // @ts-ignore
                delete url._showDetails!;
            }
            return url;
        }));
    };

    const updateParameters: (parameters: BuilderParametersByType) => void = (parameters) => {
        localStorage.setItem('utmtool-parameters', JSON.stringify(parameters))
    };

    const getParameters: () => BuilderParametersByType = () => {
        let storage = localStorage.getItem('utmtool-parameters');

        if (!storage) {

            const parameters = reactive<BuilderParametersByType>(DemoParameters);

            updateParameters(parameters);

            return parameters;
        }

        return reactive(JSON.parse(storage));
    };

    const updateBuilderSettings: (settings: ProjectBuilderSettingsInterface) => void = settings => {
        localStorage.setItem('utmtool-settings', JSON.stringify(settings));
    };

    const getBuilderSettings: () => ProjectBuilderSettingsInterface = () => {
        let storage = localStorage.getItem('utmtool-settings');

        if (!storage) {
            const settings = reactive<ProjectBuilderSettingsInterface>({
                decode: true,
                lowercase: true,
                slugify: true
            });

            updateBuilderSettings(settings);

            return settings;
        }

        return reactive(JSON.parse(storage));

    };

    const updateBuilderStats: (settings: BuilderStats) => void = settings => {
        localStorage.setItem('utmtool-builder-stats', JSON.stringify(settings));
    };

    const getBuilderStats: () => BuilderStats = () => {
        let storage = localStorage.getItem('utmtool-builder-stats');

        if (!storage) {
            const stats = reactive<BuilderStats>({
                visits: 1,
            });

            updateBuilderStats(stats);

            return stats;
        }

        return reactive(JSON.parse(storage));
    }

    return {
        updateUrls,
        getUrls,
        updateParameters,
        getParameters,
        updateBuilderSettings,
        getBuilderSettings,
        updateBuilderStats,
        getBuilderStats,
    }
}